import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { completeReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useCompleteReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: completeReturnMutate, isPending: isCompleting } = useMutation({
        mutationFn: (id) => completeReturn(id),
        onSuccess: (res) => {
            toast.success(res.message || "Return completed successfully");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to complete return");
        },
    });

    return { completeReturnMutate, isCompleting };
};
